import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findTabulateListList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/tabulateList?` + params,
        method: 'GET'
    })
}
export const findTabulateListListDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/tabulateListExcel?` + params,
        method: 'GET'
    })
}